import { render, staticRenderFns } from "./multiInstance.vue?vue&type=template&id=048d5768"
import script from "./multiInstance.vue?vue&type=script&lang=js"
export * from "./multiInstance.vue?vue&type=script&lang=js"
import style0 from "./multiInstance.vue?vue&type=style&index=0&id=048d5768&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048d5768')) {
      api.createRecord('048d5768', component.options)
    } else {
      api.reload('048d5768', component.options)
    }
    module.hot.accept("./multiInstance.vue?vue&type=template&id=048d5768", function () {
      api.rerender('048d5768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flowable/nodePanel/property/multiInstance.vue"
export default component.exports